<template>
  <div
    class="program-detail-view page"
  >
    <div
      class="page__inner"
    >
      <AppPageLoader :collection="pageCollection" :filter="pageFilter" @loaded="onPageLoaded">
        <AppProgramHero
          v-if="state.data"
          :title="state.data.title"
          :introduction="state.data.introduction"
          :image="state.data?.image"
          :mp4="state.data?.mp4"
          :hls="state.data?.hls"
          class="program-detail-view__program-hero"
        />
        <article
          v-if="state.data"
          class="program-detail-view__article"
        >
          <AppDynamicBlock
            :is="useBlock(block)"
            v-for="block in state.data.content"
            :key="`block_${block.id}`"
            :data="block"
          />
          <ClientOnly>
            <LayoutsShare v-if="state.data?.share" />
          </ClientOnly>
          <AppGridBlockStatic v-if="state.data" variant="other" />
        </article>
      </AppPageLoader>
    </div>
    <AppAnimatedTitle />
    <LayoutsFooter />
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useBlock } from '#imports'
import { AppPageLoader } from '#components'
import { TProgramPage } from '~/types/page-types'

const pageCollection = 'program_page'

// ignore pages with an external link (as they have their own website)
const pageFilter = {
  external_url: {
    _null: true
  }
}

type TState = {
  data?: TProgramPage,
};

const state: TState = reactive({
  data: undefined
})

const onPageLoaded = (data) => {
  state.data = data
}

</script>

<style scoped lang="postcss">
.program-detail-view {
  &__program-hero {
    @mixin app-show-hero;
  }

  &__article {
    position: relative;
    z-index: 20;
    background-color: var(--color-blue-prussian);
    padding-top: 1.5rem;

    @media (--lg) {
      padding-top: 2.5rem;
    }
  }
}
</style>
